var TSingleOptions = (function ()
{
    "use strict";
    var api = <any> {};

    // tsingle.js - buildAllStake
    api.buildSingle = function (mode, selections)
    {
        if (!Modes.showAllStake(mode, selections)) { return ""; }
        if (BetSlipUtil.showNAForRelatedSelections() || ComboBonusProvider.ComboBonuses)
        {
            var extraWinningRow = document.getElementById("extraWinningsRow");
            extraWinningRow && extraWinningRow.classList.add("isHidden");
        }
        BetSlipUtil.getAllBetsDepositValue(mode);

        var deposit = Bets.formatStake(mode.AllBetsDeposit);

        return TSingleOptions[BetSlipTemplateConroller.getSingleOptionsTemplate(BetSlip.TemplateType)](deposit);
    };

    api.buildRegularSingle = function(deposit)
    {
        return `
            <div id="single_options" class="betsOptions single" data-uat="single-options">
                <div class="betSlip_row_wrapper">
                    <div class="betSlip_row_content">
                        <div>
                            <span class="stakeSpan">${$dict.bs("AllStakesDeposit")}</span>
                        </div>
                    </div>
                    <div class="betSlip_row_stake">
                        ${TSlipShared.createStakeBox(getAllStakeBoxInner(deposit), deposit)}
                    </div>
                </div>
            </div>
        `;
    };

    api.buildResponsiveSingle = function(deposit)
    {
        return `
            <div id="single_options" class="bets-options-wrap single" data-uat="single-options">
                <div class="betSlip-bets-item">
                    <div class="betSlip-row-wrapper" data-uat="bet-slip-row-wrapper">
                        <div class="betSlip-row-content">
                            <div>
                                <span class="stakeSpan">${$dict.bs("AllStakesDeposit")}</span>
                            </div>
                        </div>
                        <div class="betSlip-row-stake">
                            ${TSlipShared.createStakeBox(getAllStakeBoxInner(deposit), deposit)}
                        </div>
                    </div>
                </div>
            </div>
        `;
    };

    var getAllStakeBoxInner = function (deposit)
    {
        return function (__html)
        {
            var attributes = TSlipShared.createStakeInputAttributes("UniSlipBlock.setStakeToAll(this)"),
                formattedDeposit = BetSlip.getStakeBoxValue(deposit);

                __html.push(`<input class="stakebox" id="setStakeForAll" data-uat="setStakeForAll" value="${formattedDeposit}" ${attributes} />`);
        }
    };

    return api;
}());

window.TSingleOptions = TSingleOptions;